import TemplateDirector from './TemplateDirector';

export const generateWebsiteTemplate = (website) => {

  const templateBuilder = TemplateDirector.getBuilder();
  const template = templateBuilder.buildTemplate(website);
  console.log("Template:");
  console.log(JSON.stringify(template, null, 2));

  return template;
}



// WEBPACK FOOTER //
// ./src/store/generators/websiteTemplates/index.js